Vue.component('dispatcher-list', require('./Dispatch/vue/dispatcher-list').default);
